import React from 'react';
import {
    Grid,
} from 'semantic-ui-react';

import ClinicListSearchBar from '../clinic_list_search_bar';
import ClinicListFilterByType from './clinic_list_filter_by_type';
import ClinicListFilterByArea from './clinic_list_filter_by_area';
import ClinicListFilterByCompany from './clinic_list_filter_by_company';

const ClinicListFilter = (props) => {
    // console.log('ClinicListFilter', props)
    return (
        <Grid>
            <Grid.Row columns={16}>
                <Grid.Column width={4}>
                    <ClinicListSearchBar 
                        clinics={props.clinics}
                        updateMode={props.updateMode}
                        mode={props.mode}
                    />
                </Grid.Column>
                {props.user.companies.length > 1 &&
                <Grid.Column width={4}>
                    <ClinicListFilterByCompany 
                        user={props.user}
                        filterOptions={props.filterOptions}
                        updateClinicFilterOptions={props.updateClinicFilterOptions}
                        updateMode={props.updateMode}
                    />
                </Grid.Column>}
                <Grid.Column width={4}>
                    <ClinicListFilterByType 
                        typeList={props.typeList}
                        filterOptions={props.filterOptions}
                        updateClinicFilterOptions={props.updateClinicFilterOptions}
                        updateMode={props.updateMode}
                    />
                </Grid.Column>
                <Grid.Column width={4}>
                    <ClinicListFilterByArea 
                        areaList={props.areaList}
                        filterOptions={props.filterOptions}
                        updateClinicFilterOptions={props.updateClinicFilterOptions}
                        updateMode={props.updateMode}
                    />
                </Grid.Column>
            </Grid.Row>
        </Grid>
    );
}

export default ClinicListFilter;

/*
<Grid.Row columns={2}>
    <Grid.Column>
        Search Bar 1
    </Grid.Column>
    <Grid.Column>
        Search Bar 2
    </Grid.Column>
</Grid.Row>
*/